const HasLoadedPublicId = "EverythingHasLoaded";

//This can be used for checkly to make sure things are loaded
const HasLoaded = () => {
  return <div id={HasLoadedPublicId} />;
};

export default HasLoaded;
